export const LOG_IN = "LOG_IN";
export type LOG_IN = typeof LOG_IN;

export const LOG_OUT = "LOG_OUT";
export type LOG_OUT = typeof LOG_OUT;
